import angular from 'angular';
import floatingHelper from './floatingHelper';

export default angular
  .module('components.floatingHelper', [])
  .component('floatingHelper', floatingHelper).name;
